import React, { useState, useEffect } from "react"
import { useToasts } from "react-toast-notifications"
import FullLoader from "../../components/Loaders/FullLoader"
import ModalContainer from "../../components/ModalContainer/ModalContainer"
import DashboardNavbar from "../../components/Navbar/DashboardNavbar"
import { useEvent } from "../../context/EventContext"
import { createRegistries } from "../../utils/ApiRequests"
import { getApiErrorMessage } from "../../utils/ApiUtils"
import { handleChange } from "../../utils/FormUtils"
import ProgressBar from "../../components/ProgressBar/ProgressBar"

// import EventNavbar from "../../components/Navbar/EventNavbar"

const EventPage2 = ({ formStep }) => {
  const [showModal, setShowModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [form, setForm] = useState({
    name: ""
  })
  const [isPublic, setIsPublic] = useState("")
  const { currentEvent, setCurrentRegistry } = useEvent()
  const { addToast } = useToasts()

  const CreateRegistry = e => {
    e.preventDefault()
    setLoading(true)
    createRegistries({
      ...{
        event: currentEvent,
        is_public: isPublic
      },
      ...form
    })
      .then(res => {
        setShowModal(true)
        setLoading(false)
        setCurrentRegistry(res.data?.data?._id)
      })
      .catch(err => {
        setLoading(false)
        console.log(err.response?.message)
        addToast(getApiErrorMessage(err.response?.message), {
          appearance: "error",
          autoDismiss: true
        })
      })
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <section className="relative min-h-screen">
        {showModal && (
          <ModalContainer>
            <div className=" py-8 px-10 bg-sbg-white max-w-4xl">
              <p className="mb-5 text-grey">
                We have successfully created your registry. Let’s get started
                with adding products to your registry.
              </p>

              <button
                className="mx-auto block bg-sbg-light-green px-16 py-3 text-center text-white rounded-md focus:outline-none"
                onClick={() => {
                  setShowModal(false)
                  formStep(3)
                }}
              >
                Add Products
              </button>
            </div>
          </ModalContainer>
        )}

        {loading && <FullLoader />}

        <DashboardNavbar />

        <form
          className="global-container pt-24 mx-auto relative z-10 flex flex-col justify-center items-center"
          onSubmit={e => CreateRegistry(e)}
        >
          <ProgressBar selected={2} />

          <h5 className="font-bold self-start w-8/12 mx-auto text-2xl text-grey my-10 medium:text-center">
            Create registry
          </h5>

          {/* Entrry One for the event page  */}

          <div className="w-8/12 medium:w-full mb-10">
            <div className="flex justify-between w-full">
              <div className="border border-sbg-grey h-12 w-12 rounded-full flex items-center justify-center">
                <h1 className="text-grey">1</h1>
              </div>

              <div className="w-10/12 ">
                <h1 className="text-grey text-xl ">
                  Choose a name for your registry
                </h1>
                <p className="text-grey text-sm my-1.5 ">
                  Enter a title for your registry. This will be publicly
                  displayed to your guests.
                </p>
              </div>
            </div>
            <div className="py-6 px-10 medium:px-6 bg-sbg-light-grey w-5/6 ml-auto flex flex-wrap justify-between medium:w-full medium:justify-center ">
              <input
                placeholder="Enter your registry's name"
                className="w-full py-4 px-3 focus:outline-none text-grey"
                name="name"
                value={form.name}
                onChange={e => handleChange(e, form, setForm)}
                required
              />
            </div>
          </div>

          {/* End of entry one the event page */}

          <div className="w-8/12 medium:w-full mb-10">
            <div className="flex justify-between w-full">
              <div className="border border-sbg-grey h-12 w-12 rounded-full flex items-center justify-center">
                <h1 className="text-grey">2</h1>
              </div>

              <div className="w-10/12 ">
                <h1 className="text-grey text-xl ">
                  Should this registry show up on public registry
                </h1>
                <p className="text-grey text-sm my-1.5 ">
                  Let’s know if you want your registry to appear in our public
                  registeries
                </p>
              </div>
            </div>
            <div className="py-6 px-10 medium:px-6 bg-sbg-light-grey w-5/6 ml-auto flex flex-wrap medium:w-full medium:justify-center ">
              <div
                className={`w-24 h-12 ${
                  isPublic === true
                    ? `bg-sbg-light-grey-2 text-white`
                    : `bg-sbg-white text-grey`
                } flex items-center justify-center text-center cursor-pointer`}
                onClick={() => setIsPublic(true)}
              >
                Yes
              </div>

              <div
                className={`w-24 h-12  flex ${
                  isPublic === false
                    ? `bg-sbg-light-grey-2 text-white`
                    : `bg-sbg-white text-grey`
                } items-center justify-center text-center ml-4 cursor-pointer`}
                onClick={() => setIsPublic(false)}
              >
                No
              </div>
            </div>
          </div>

          {/* End of Second entry for evnt page */}

          <div className="w-8/12 medium:w-full mb-10">
            <div className="flex justify-between w-full">
              <div className="border border-sbg-grey h-12 w-12 rounded-full flex items-center justify-center ">
                <h1 className="text-grey">3</h1>
              </div>

              <div className="w-10/12 ">
                <h1 className="text-grey text-xl ">
                  Enter your registry start date
                </h1>
                <p className="text-grey text-sm my-1.5 ">
                  Select the start date of your registry
                </p>
              </div>
            </div>
            <div className="py-6 px-10 medium:px-6 bg-sbg-light-grey w-5/6 ml-auto flex flex-wrap medium:w-full medium:justify-center ">
              <input
                className="w-full py-4 px-3 focus:outline-none text-grey"
                type="date"
                required
                name="start_date"
                onChange={e => handleChange(e, form, setForm)}
              />
            </div>
          </div>

          <div className="w-8/12 medium:w-full mb-10">
            <div className="flex justify-between w-full">
              <div className="border border-sbg-grey h-12 w-12 rounded-full flex items-center justify-center ">
                <h1 className="text-grey">4</h1>
              </div>

              <div className="w-10/12 ">
                <h1 className="text-grey text-xl ">
                  Enter your registry end date
                </h1>
                <p className="text-grey text-sm my-1.5 ">
                  Select the end date of your registry
                </p>
              </div>
            </div>
            <div className="py-6 px-10 medium:px-6 bg-sbg-light-grey w-5/6 ml-auto flex flex-wrap medium:w-full medium:justify-center ">
              <input
                className="w-full py-4 px-3 focus:outline-none text-grey"
                type="date"
                name="end_date"
                onChange={e => handleChange(e, form, setForm)}
                required
              />
            </div>
          </div>

          {/* End of third entry */}

          <div className="w-8/12 medium:w-full ">
            <div className="w-4/6 flex items-center justify-around ml-auto medium:w-full">
              <button
                className="my-14 mx-auto block bg-sbg-white px-12 py-3 text-center text-lgreen border border-sbg-light-green rounded-md focus:outline-none"
                onClick={() => formStep(1)}
              >
                Back
              </button>

              <button
                className="my-14 mx-auto block bg-sbg-light-green px-10 py-3 text-center text-white rounded-md focus:outline-none"
                type="submit"
              >
                Create Registry
              </button>
            </div>
          </div>
        </form>
      </section>
    </>
  )
}

export default EventPage2
